<template>
  <div class="eclipsa">
    <h1>Râmnicu Vâlcea: Sonnenfinsternis, Eclipsa 1999</h1>
    <article>
      Doriţi o prelungare? Faceţi un click pe o posa!
      Posele marcat cu "nn" nu sânt de la mine.<br/>
				Klicken Sie auf ein Foto, 
				um eine Vergrößerung zu erhalten<br>
				Mit (nn) markierte Fotos stammen nicht von mir.
    </article>
    <article class="fotos">
      <div class="foto">
        <img src="../assets/fotos/sonne3kl.jpg" width="125" border="0" height="110" alt="Râmnicu Vâlcea: Sonnenfinsternis, Eclipsa 1999" 
        @click="callImageClick('Râmnicu Vâlcea: Sonnenfinsternis, Eclipsa 1999', 'sonne3.jpg', $event)">
        <br>Sonnenfinsternis, Eclipsa 1999
      </div>
      <div class="foto">
        <img src="../assets/fotos/sonne9kl.jpg" width="125" border="0" height="110" alt="Râmnicu Vâlcea: Sonnenfinsternis, Eclipsa 1999" 
        @click="callImageClick('Râmnicu Vâlcea: Sonnenfinsternis, Eclipsa 1999', 'sonne9.jpg', $event)">
        <br>Sonnenfinsternis, Eclipsa 1999
      </div>
      <div class="foto">
        <img src="../assets/fotos/sonn13kl.jpg" width="125" border="0" height="110" alt="Râmnicu Vâlcea: Sonnenfinsternis, Eclipsa 1999" 
        @click="callImageClick('Râmnicu Vâlcea: Sonnenfinsternis, Eclipsa 1999', 'sonn13.jpg', $event)">
        <br>Sonnenfinsternis, Eclipsa 1999
      </div>
      <div class="foto">
        <img src="../assets/fotos/sonn16kl.jpg" width="125" border="0" height="110" alt="Râmnicu Vâlcea: Sonnenfinsternis, Eclipsa 1999" 
        @click="callImageClick('Râmnicu Vâlcea: Sonnenfinsternis, Eclipsa 1999', 'sonn16.jpg', $event)">
        <br>Sonnenfinsternis, Eclipsa 1999
      </div>
      <div class="foto">
        <img src="../assets/fotos/sonn17kl.jpg" width="125" border="0" height="110" alt="Râmnicu Vâlcea: Sonnenfinsternis, Eclipsa 1999" 
        @click="callImageClick('Râmnicu Vâlcea: Sonnenfinsternis, Eclipsa 1999', 'sonn17.jpg', $event)">
        <br>Sonnenfinsternis, Eclipsa 1999
      </div>
      <div class="foto">
        <img src="../assets/fotos/sonn26kl.jpg" width="125" border="0" height="110" alt="Râmnicu Vâlcea: Sonnenfinsternis, Eclipsa 1999" 
        @click="callImageClick('Râmnicu Vâlcea: Sonnenfinsternis, Eclipsa 1999', 'sonn26.jpg', $event)">
        <br>Sonnenfinsternis, Eclipsa 1999
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: 'home',
  methods: {
  callImageClick(imgText, imgName, event) {
     this.$parent.handleImageClick(imgText, imgName, event);
    }
  }
}
</script>